import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Modal, FormInput, FormSelect } from '../../components'
import { fetchResource, updateResource, createResourceLibrary } from '../../api'
import { back, replace } from '../../actions/nav-actions';
import { retrieve } from '../../actions/resources-actions';
import { Constants } from '../../defaults';
import { notify } from '../../utils'

const types = [
    { value: 'blog-post', label: 'Blog Post' },
    { value: 'book', label: 'Book' },
    { value: 'journal-article', label: 'Journal Article' },
    { value: 'presentation', label: 'Presentation' },
    { value: 'podcast', label: 'Podcast' },
    { value: 'report', label: 'Report' }
];

class Form extends Component {
    constructor(props) {
        super(props);
        const params = props.match.params || {};
        this.state = {
            key: params.key,
            resource: {},
            modal_visible: true
        }
        this.getData = this.getData.bind(this);
        this.onRequest = this.onRequest.bind(this);
    }
    componentDidMount() {
        this.getData();
    }
    getData() {
        if (!this.state.key) return;
        fetchResource(
            this.props.user.token,
            this.state.key
        ).then((resource) => {
            this.setState({ resource });
        }).catch((err) => {
            alert(err.message);
        })
    }
    componentWillReceiveProps(newProps) {
        const params = newProps.match.params || {};
        if (params.key !== this.state.key) {
            this.setState({ key: params.key, modal_visible: true }, this.getData);
        }
    }
    onRequest() {
        if (this.state.resource.key) {
            notify("Update informations", "Updating...")
            updateResource(
                this.props.user.token,
                this.state.resource.key,
                { ...this.state.resource }
            ).then((resource) => {
                this.setState({ resource });
                notify("Update informations", "Successfully updated!");
                this.props.retrieve(this.props.user.token);
            }).catch(err => {
                alert(err.message);
            })
            return;
        }
        notify("Update informations", "Creating...")
        createResourceLibrary(
            this.props.user.token,
            {
                ...this.state.resource
            }
        ).then((resource) => {
            this.setState({ resource }, () => {
                notify("Update informations", "Successfully created!");
                this.props.replace(`/library/${resource.key}`);
                this.props.retrieve(this.props.user.token);
            });
        }).catch(err => {
            alert(err.message);
        })
    }
    render() {
        return (
            <Modal
                visible={this.state.modal_visible}
                onClose={() => this.setState({ modal_visible: false }, this.props.back)}
                title={this.state.resource.key ? 'Update Resource' : 'New Resource'}
                action_text={this.state.resource.key ? 'UPDATE RESOURCE' : "ADD RESOURCE"}
                onActionClick={this.onRequest}>

                <FormInput
                    onChange={(title) => {
                        let { resource } = this.state;
                        resource.title = title;
                        this.setState({ resource });
                    }}
                    value={this.state.resource.title}
                    placeholder="Title" />

                <FormInput
                    onChange={(author) => {
                        let { resource } = this.state;
                        resource.author = author;
                        this.setState({ resource });
                    }}
                    value={this.state.resource.author}
                    placeholder="Author" />

                <FormInput
                    onChange={(publisher) => {
                        let { resource } = this.state;
                        resource.publisher = publisher;
                        this.setState({ resource });
                    }}
                    value={this.state.resource.publisher}
                    placeholder="Publisher" />

                {!this.state.resource.key &&
                    <FormInput
                        onChange={(url) => {
                            let { resource } = this.state;
                            resource.url = url;
                            this.setState({ resource });
                        }}
                        value={this.state.resource.url}
                        placeholder="URL" />
                }

                {this.state.resource.key &&
                    <div style={{ marginBottom: 8, display: 'flex', flexDirection: 'column' }}>
                        <FormInput
                            onChange={(url) => {
                                let { resource } = this.state;
                                resource.url = url;
                                this.setState({ resource });
                            }}
                            value={this.state.resource.url}
                            containerStyle={{ marginBottom: 0, flex: 1 }}
                            placeholder="URL" />
                        <a target="_blank" style={{ alignSelf: 'flex-end', marginTop: 4, fontSize: 14 }} href={this.state.resource.url}><i className="mdi mdi-open-in-new"></i> GO TO LINK</a>
                    </div>
                }

                <FormInput
                    onChange={(abstract) => {
                        let { resource } = this.state;
                        resource.abstract = abstract;
                        this.setState({ resource });
                    }}
                    value={this.state.resource.abstract}
                    placeholder="Abstract" />


                <FormSelect
                    onChange={(option) => {
                        let { resource } = this.state;
                        resource.type = option ? option.value : undefined;
                        this.setState({ resource });
                    }}
                    placeholder="Type"
                    searchable
                    value={this.state.resource.type}
                    options={types} />

                <FormSelect
                    multi={true} removeSelected={false}
                    onChange={(options) => {
                        let { resource } = this.state;
                        resource.tags = options ? options.map(o => o.value) : undefined;
                        this.setState({ resource });
                    }}
                    placeholder="Tags"
                    searchable style={{ marginTop: '20px' }}
                    value={this.state.resource.tags}
                    options={Constants.TAGS.map((t) => ({ label: t, value: t }))} />

                <FormSelect
                    multi={true} removeSelected={false}
                    onChange={(options) => {
                        let { resource } = this.state;
                        resource.sections = options ? options.map(o => o.value) : undefined;
                        this.setState({ resource });
                    }}
                    placeholder="Sections"
                    searchable style={{ marginTop: '20px' }}
                    value={this.state.resource.sections}
                    options={Constants.SECTIONS.map((t) => ({ label: t, value: t }))} />
            </Modal>
        )
    }
}

const mapStateToProps = state => ({ user: state.authReducer.user })

const mapDispatchToProps = dispatch => ({
    back() {
        dispatch(back());
    },
    retrieve(token) {
        dispatch(retrieve(token));
    },
    replace(routeName) {
        dispatch(replace(routeName))
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(Form)


// WEBPACK FOOTER //
// ./src/routers/Library/Form.js